import React from 'react'
import { useUser } from '../../context/UserContext';

export default function ActionDropdown({page = '', action = '', setAction = () => {}}) {

  const { user, handleLogout } = useUser();
  const current_role_key = user?.role_key;

  const handleActionChange = (e) => {
    setAction({ ...action, [e.target.name]: e.target.value });
  };

  return (
    
    <div className="col search_filter_user col-md-7">
      <select
        className="custom_form_control w-100"
        as="select"
        id="selectfilter"
        name="action"
        value={action}
        onChange={handleActionChange}
      >
        <option key="" value="">
          Select Action
        </option>
        {page === 'accounts' ? (
          <>
            <option key="status_on" value="status_on">
                Publish
            </option>
            <option key="status_off" value="status_off">
                Unpublish
            </option>

            {current_role_key === 'SUPER_ADMIN' &&
            <>
            <option key="is_avail_for_demo_on" value="is_avail_for_demo_on">
                Avail for Demo
            </option>

            <option key="is_avail_for_demo_off" value="is_avail_for_demo_off">
                Unavail for Demo
            </option>
            </>
            }
          </>) : (<></>)}
        <option key="activate" value="activate">
          Activate
        </option>
        <option key="deactivate" value="deactivate">
          Deactivate
        </option>
        {page === 'users' ? (
          <>
            {/* <option key="verified" value="verified">
              Verified
            </option>
            <option key="not_verified" value="not_verified">
              Not Verified
            </option> */}
            {/* <option key="newsletter_active" value="newsletter_active">
            Newsletter Active
            </option>
            <option key="newsletter_deactive" value="newsletter_deactive">
            Newsletter Deactive
            </option> */}
          </>) : (<></>)}
        <option key="delete" value="delete">
          Delete
        </option>

        {/* <option key="undo_delete" value="undo_delete">
          Restore
        </option> */}
        
      </select>
    </div>
  );
}
